import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import Autorizado from "../../Autorizado";
import { TableHeader, Pagination, Search } from "../../../DataTable"
import useFullPageLoader from "../../../hooks/useFullPageLoader"
import moment from 'moment';

import { v4 as uuidv4 } from "uuid";

function ListadoCompraVenta() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_COMPRA_VENTA = process.env.REACT_APP_URL_COMPRA_VENTA;
  const URL_ARTICULOS_COMPRA_VENTA = process.env.REACT_APP_URL_ARTICULOS_COMPRA_VENTA;
  const URL_SOCIEDADES = process.env.REACT_APP_URL_SOCIEDADES;
  // const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-60);

  let validaInter = new Date()
  validaInter.setDate(validaInter.getDate()+15);

  let validaNac = new Date()
  validaNac.setDate(validaNac.getDate()+8);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");
  let validadorInter   = moment(validaInter).format("YYYY-MM-DD");
  let validadorNac   = moment(validaNac).format("YYYY-MM-DD");

  const [compraVenta, setCompraVenta] = useState([]);

  const [telas, setTelas] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [artOC, setArtOC] = useState([]);
  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");

  const [sociedades, setSociedades] = useState([]);
  const [selectedSociedadVenta, setSelectedSociedadVenta] = useState("");
  const [selectedSociedadCompra, setSelectedSociedadCompra] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [selectedTipo, setSelectedTipo] = useState("");
  const [empresa, setEmpresa] = useState("");

  const [fecha, setFecha] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState("");
  const [total_kilos, setTotalUnidaKilos] = useState("");
  const [total_metros, setTotalUnidaMetros] = useState("");
  const [total_piezas, setTotalUnidaPiezas] = useState("");
  const [tipo, setTipo] = useState("");

  const [idEdit, setIdEdit] = useState("");
  const [selectedSociedadEdit, setSelectedSociedadEdit] = useState("");

  const [telasOrden, setTelasOrden] = useState([]);
  const [articulosOrden, setArticulosOrden] = useState([]);
  const [modalEditTelas, setModalEditTelas] = useState(false);
  const toggleEditTelas = () => setModalEditTelas(!modalEditTelas);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [total_general_edit, setTotalGeneralEdit] = useState(0);
  const [total_kilos_edit, setTotalKilosEdit] = useState(0);
  const [total_metros_edit, setTotalMetrosEdit] = useState(0);
  const [total_piezas_edit, setTotalPiezasEdit] = useState(0);


  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      telas: "",
      unidad: 0,
      colores: "",
      // arrayColoresTela:[],
      cantidad: 0,
      precio: 0,
      descuento: 0,
      total: 0,
      observaciones: "NA"
    },
  ]);

  const [inputFieldsHab, setInputFieldsHab] = useState([
    {
      id: uuidv4(),
      articulos: "",
      unidad: 0,
      cantidad: 0,
      precio: 0,
      descuento: 0,
      total: 0,
      observaciones: "NA"
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [status, setStatus] = useState('Abierto');
  const [pagado, setPagado] = useState('');
  const [autorizado, setAutorizado] = useState('');

    //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50

  useEffect(() => {
    axios
      .get(`${URL_COMPRA_VENTA}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allOrdenes = response.data;
        console.log("hola",allOrdenes);
    // Array para pagination
    let arrayTabla = allOrdenes
    .sort((a, b) => (a.idCompraVenta < b.idCompraVenta ? 1 : -1))
    .map((a) => {
      return {
        _id:a._id,
        numero: a.idCompraVenta,
        activo: a.is_active,
        fecha: a.fecha,
        sociedadVenta: a.sociedadVenta[0].nombre,
        sociedadCompra: a.sociedadCompra[0].nombre,
        observaciones: a.observaciones,
        total_general: a.total_general,
        idSociedadVenta: a.sociedadVenta[0]._id,
        idSociedadCompra: a.sociedadCompra[0]._id,
        total_kilos: a.total_kilos,
        total_metros: a.total_metros,
        total_piezas: a.total_piezas,
        tipo:a.tipo,
        pagado:a.pagado
      };
    }).filter(function (el) {
      return el != null;
    });

    let dataFinal = Object.values(arrayTabla);

    setCompraVenta(allOrdenes);
    setComments(dataFinal)
    //

      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_SOCIEDADES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSociedades = response.data;
        setSociedades(allSociedades);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTelas = response.data;
        setTelas(allTelas);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_COLORES, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allColores = res.data;
          setColores(allColores);
        })
        .catch((err) => {
          console.log(err);
        });

      axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);
// console.log("hola",comments)

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
          (pagado == 0 ||
            pagado == a.pagado) &&
            (selectedSociedadVenta == 0 ||
              selectedSociedadVenta == a.idSociedadVenta)&&
              (selectedSociedadCompra == 0 ||
                selectedSociedadCompra == a.idSociedadCompra)&&
              (selectedTipo == "" ||
                selectedTipo == a.tipo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.sociedades,
          a.tipo,
          // a.clientes,
          a.fecha_compromiso,
          // a.fecha_cita,
          // a.fecha_cancelacion_pedido,
          // a.fecha_creacion_prepedido,
          a.observaciones,
          a.total_kilos,
          a.total_metros,
          a.total_piezas,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general),
         ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Compra Venta`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Sociedad",
          "Tipo",
          // "Cliente",
          "Fecha Comp",
          // "Fecha Cita",
          // "Fecha Canc. Ped.",
          // "Fecha Crea. PrePed.",
          "Observaciones",
          "Kilos",
          "Metros",
          "Piezas",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ordenes-Compra.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (pagado == 0 ||
          pagado == a.pagado) &&
            (selectedSociedadVenta == 0 ||
              selectedSociedadVenta == a.idSociedadVenta)&&
              (selectedSociedadCompra == 0 ||
                selectedSociedadCompra == a.idSociedadCompra)&&
              (selectedTipo == "" ||
                selectedTipo == a.tipo)
      ) {
        return {
          Numero:a.numero,
          FechaCreacion: a.fecha,
          Sociedad: a.sociedades,
          Tipo: a.tipo,
          // Cliente: a.clientes,
          FechaComp: a.fecha_compromiso,
          // FechaCita: a.fecha_cita,
          // FechaCancPed: a.fecha_cancelacion_pedido,
          // FechaCreaPrePed: a.fecha_creacion_prepedido,
          Observaciones: a.observaciones,
          Kilos: a.total_kilos,
          Metros: a.total_metros,
          Piezas:a.total_piezas,
          Total: a.total_general,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoCompraVenta";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoCompraVenta",
        sheetFilter: [
          "Numero",
          "FechaCreacion",
          "Sociedad",
          "Tipo",
          // "Cliente",
          "FechaComp",
          // "FechaCita",
          // "FechaCancPed",
          // "FechaCreaPrePed",
          "Observaciones",
          "Kilos",
          "Metros",
          "Piezas",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "FechaCreacion",
          "Sociedad",
          "Tipo",
          // "Cliente",
          "FechaComp",
          // "FechaCita",
          // "FechaCancPed",
          // "FechaCreaPrePed",
          "Observaciones",
          "Kilos",
          "Metros",
          "Piezas",
          "Total",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (pagado == 0 ||
          pagado == a.pagado) &&
            (selectedSociedadVenta == 0 ||
              selectedSociedadVenta == a.idSociedadVenta)&&
              (selectedSociedadCompra == 0 ||
                selectedSociedadCompra == a.idSociedadCompra)&&
              (selectedTipo == "" ||
                selectedTipo == a.tipo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.sociedades,
          a.tipo,
          // a.clientes,
          a.fecha_compromiso,
          // a.fecha_cita,
          // a.fecha_cancelacion_pedido,
          // a.fecha_creacion_prepedido,
          a.observaciones,
          a.total_kilos,
          a.total_metros,
          a.total_piezas,
          "$" + new Intl.NumberFormat("en-US").format(a.total_general),
         ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado Compra Venta`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Sociedad",
          "Tipo",
          // "Cliente",
          "Fecha Comp",
          // "Fecha Cita",
          // "Fecha Canc. Ped.",
          // "Fecha Crea. PrePed.",
          "Observaciones",
          "Kilos",
          "Metros",
          "Piezas",
          "Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ordenes Compra",
          email: mailTo,
          fileName: "ListadoCompraVenta.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Compra Venta.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  let IVAPDF = 0
  let totalPDF = 0
 async function PDFOC(   
  fecha,
  sociedadVenta,
  sociedadCompra,
  total_kilos,
  total_metros,
  total_piezas,
  total_general,
  observaciones,
  numero,
  tipo,
  idPDFOC ) {
     await axios
      .get(`${URL_ARTICULOS_COMPRA_VENTA}/compraVenta/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allTelasOrden = response.data
        if(tipo =="Tela"){
        let arrayTabla = allTelasOrden
        .map((a) => {
          return {
            id:a._id,
            articulo: a.telas[0].codigo + " " + a.telas[0].nombre,
            unidad: a.telas[0].unidad,
            colores: a.colores[0].name,
            cantidad: a.cantidad,
            precio: a.precio,
            descuento: a.descuento,
            total: a.total,
          };
        }).filter(function (el) {
          return el != null;
        })
        var dataFinal = Object.values(arrayTabla);
      } else{
        let arrayTabla = allTelasOrden
        .map((a) => {
          return {
            id:a._id,
            articulo: a.articulos[0].codigo + " " + a.articulos[0].descripcion,
            descripcion: a.articulos[0].descripcion,
            unidad: a.articulos[0].unidad,
            colores: "NA",
            cantidad: a.cantidad,
            precio: a.precio,
            descuento: a.descuento,
            total: a.total,
          };
        }).filter(function (el) {
          return el != null;
        });
        var dataFinal = Object.values(arrayTabla); 
        }
    
         

        let mts = dataFinal.filter(e=>e.unidad == "Metros")
        let totalMts = mts.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        setTotalMetrosEdit(TM);
        let KG = dataFinal.filter(e=>e.unidad == "Kilos")
        let totalKG = KG.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);
        setTotalKilosEdit(TK);
        let PZ = dataFinal.filter(e=>e.unidad == "Piezas")
        let totalPZ = PZ.map((c) => parseFloat(c.cantidad));
        let TP = totalPZ.reduce((t, total, index) => t + total, 0);
        setTotalPiezasEdit(TP);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);


        if(tipo == "Tela"){
        const data = dataFinal.map((a) => {
            return [
              a.articulo,
              a.unidad,
              a.colores,
              new Intl.NumberFormat("en-US").format(a.cantidad),
              "$" + new Intl.NumberFormat("en-US").format(a.precio),
              "$" + new Intl.NumberFormat("en-US").format(a.total),
             ]
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 120, 15, 60, 25);
        doc.text(`Orden de Compra # ${numero}`, 20, 20);
        doc.setFontSize(12)
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Sociedad Venta ${sociedadVenta}`, 20, 30);
        doc.text(`Sociedad Compra ${sociedadCompra}`, 20, 35);
        doc.text(`Metros ${new Intl.NumberFormat("en-US").format(total_metros)} / Kilos ${new Intl.NumberFormat("en-US").format(total_kilos)} / Piezas ${new Intl.NumberFormat("en-US").format(total_piezas)}`, 20, 40)
        doc.text(`Observaciones ${observaciones}`, 20, 45);
        doc.autoTable({
          head: [
            [
              "Articulo",
              "Unidad",
              "Color",
              "Cantidad",
              "Precio",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          startY: 50,
          foot: [
            [
              "",
              "",
              "",
              "",
              "Total",
              "$" + new Intl.NumberFormat("en-US").format(total_general),
            ],
          ],
          showFoot: "lastPage",
        });
        // doc.save(`OC-${numero}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
    }else{
        const data = dataFinal.map((a) => {
            return [
              a.articulo,
              new Intl.NumberFormat("en-US").format(a.cantidad),
              "$" + new Intl.NumberFormat("en-US").format(a.precio),
              "$" + new Intl.NumberFormat("en-US").format(a.total),
             ]
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF("landscape");
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 230, 30, 45, 15);
        // var img2 = new Image();
        // img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        // doc.addImage(img2, "png", 120, 15, 60, 25);
        doc.setFontSize(14)
        doc.text(`Empresa ${empresa}`, 20, 15);
        doc.text(`Orden de Compra # ${numero}`, 20, 20);
        doc.setFontSize(12)
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Sociedad Venta ${sociedadVenta}`, 20, 30);
        doc.text(`Sociedad Compra ${sociedadCompra}`, 20, 35);
        doc.text(`Metros ${new Intl.NumberFormat("en-US").format(total_metros)} / Kilos ${new Intl.NumberFormat("en-US").format(total_kilos)} / Piezas ${new Intl.NumberFormat("en-US").format(total_piezas)}`, 20, 40)
        doc.text(`Observaciones ${observaciones}`, 20, 45);
        doc.autoTable({
          head: [
            [
              "Articulo",
              "Cantidad",
              "Precio",
              "Total",
            ],
          ],
          body: dataPDFLimpia,
          startY: 50,
          foot: [
            [
              "",
              "",
              "Total",
              "$" + new Intl.NumberFormat("en-US").format(total_general),
            ],
          ],
          showFoot: "lastPage",
        });
        // doc.save(`OC-${numero}.pdf`);
        window.open(doc.output("bloburl"), "_blank");
    }
      })
      .catch((err) => {
        console.log(err);
      });

     
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Sociedad Venta", field: "sociedadVenta", sortable: false },
    { name: "Sociedad Compra", field: "sociedadCompra", sortable: false },
    { name: "Tipo", field: "tipo", sortable: false },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Kilos", field: "total_kilos", sortable: true },
    { name: "Metros", field: "total_metros", sortable: true },
    { name: "Piezas", field: "total_piezas", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Pagar", field: "pagar", sortable: false },
    // { name: "Editar", field: "editar", sortable: false },
];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.sociedadVenta.toLowerCase().includes(search.toLowerCase()) ||
          comment.sociedadCompra.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.total_kilos.toString().includes(search) ||
          comment.total_metros.toString().includes(search) ||
          comment.total_piezas.toString().includes(search) ||
          comment.total_general.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedSociedadVenta) {
      computedComments = computedComments.filter((e) =>
        e.idSociedadVenta.includes(selectedSociedadVenta)
      );
    }
    if (selectedSociedadCompra) {
      computedComments = computedComments.filter((e) =>
        e.idSociedadCompra.includes(selectedSociedadCompra)
      );
    }
    if (pagado) {
      computedComments = computedComments.filter((e) =>
        e.pagado.includes(pagado)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedTipo) {
      computedComments = computedComments.filter((e) =>
        e.tipo.includes(selectedTipo)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total_kilos" &&
      sorting.field != "total_metros" &&
      sorting.field != "total_piezas" &&
      sorting.field != "total_general" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total_kilos" ||
        sorting.field == "total_metros" ||
        sorting.field == "total_piezas" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total_kilos" ||
        sorting.field == "total_metros" ||
        sorting.field == "total_piezas" ||
        sorting.field == "total_general" ||
        sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    pagado,
    autorizado,
    selectedFechaInicio,
    selectedFechaFin,
    selectedSociedadVenta,
    selectedSociedadCompra,
    selectedTipo,
  ]);


function desautorizar(idEdit) {
  Swal.fire({
    title: "Estas seguro?",
    text: "Se marcará como no pagado!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, marcar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .patch(
          `${URL_COMPRA_VENTA}/${idEdit}`,
          {
            pagado: "No",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          const newComments = comments.map((i) => {
            if (idEdit === i._id) {
              i.pagado = "No";
            }
            return i;
          });
          setComments(newComments);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se marco como no pagado",
            showConfirmButton: false,
            timer: 2000,
          });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }
  });
}

function autorizar(idEdit) {
  Swal.fire({
    title: "Estas seguro?",
    text: "Se marcará como pagado!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, marcar!",
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .patch(
          `${URL_COMPRA_VENTA}/${idEdit}`,
          {
            pagado: "Si",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          const newComments = comments.map((i) => {
            if (idEdit === i._id) {
              i.pagado = "Si";
            }
            return i;
          });
          setComments(newComments);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se marco como pagado",
            showConfirmButton: false,
            timer: 2000,
          });
          // setTimeout(() => {
          //   window.location.reload();
          // }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }
  });
}

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_oc ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.oc_create ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/CompraVentaCreate"
                >
                  Nueva
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nueva
                </Button>
              )}
              <Button
                size="sm"
                href="/MenuRetiros"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Compra Venta</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Compra Venta</h3>
          <div className="row">
                        <div className="col-md-8">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
                        <div className="col-md-4 d-flex flex-row-reverse">
                            <Search
                                onSearch={value => {
                                    setSearch(value);
                                    setCurrentPage(1);
                                }}
                            />
                        </div>
                    </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          
            <Col md={2}>
              <Label>Pagado</Label>
              <Input
                bsSize="sm"
                type="select"
                value={pagado}
                required
                onChange={(e) => {
                  setPagado(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Si</option>
                <option value="No">No</option>
              </Input>
            </Col>

          </Row>
            <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader headers={headers} onSorting={(field, order) => setSorting({ field, order }) } />
            <tbody>
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedSociedadVenta}
                onChange={(e) => {
                  setSelectedSociedadVenta(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="0">Selecciona</option>
                {sociedades
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre}</option>;
                  })}
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedSociedadCompra}
                onChange={(e) => {
                  setSelectedSociedadCompra(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="0">Selecciona</option>
                {sociedades
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.nombre}</option>;
                  })}
              </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                bsSize="sm"
                type="select"
                value={selectedTipo}
                onChange={(e) => {
                  setSelectedTipo(e.target.value)
                  setCurrentPage(1)
                }}
              >
                <option value="">Selecciona</option>
                <option value="Tela">Tela</option>
                <option value="Articulos">Articulos</option>
              </Input>
              </td>
            </tr>
            </tbody>
            <tbody>
              {commentsData.map((a) => {
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.sociedadVenta}</td>
                      <td>{a.sociedadCompra}</td>
                      <td>{a.tipo}</td>
                      <td>{a.observaciones}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_kilos)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_metros)}</td>
                      <td>{new Intl.NumberFormat("en-US").format(a.total_piezas)}</td>
                      <td>{"$" + new Intl.NumberFormat("en-US").format(a.total_general)} </td>
                      <td>
                        {user.oc_create ? (
                          <div>
                           {user.oc_autorizacion ? (
                             <>
                             {a.pagado == "Si" ? (
                                  <span>
                                    <Button
                                      color="danger"
                                      id="Baja"
                                      onClick={(e) =>
                                        desautorizar(
                                          a._id
                                        )
                                      }
                                      size="sm"
                                    >
                                      <i class="fas fa-dollar-sign"></i>
                                    </Button>
                                  </span>
                                ) : (
                                  <span>
                                    <Button
                                      color="primary"
                                      onClick={(e) =>
                                        autorizar(
                                          a._id
                                        )
                                      }
                                      size="sm"
                                    >
                                      <i class="fas fa-dollar-sign"></i>
                                    </Button>
                                  </span>
                                )}
                             </>
                           ) : (undefined)}

                            <Button
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) => PDFOC( 
                                a.fecha,
                                a.sociedadVenta,
                                a.sociedadCompra,
                                a.total_kilos,
                                a.total_metros,
                                a.total_piezas,
                                a.total_general,
                                a.observaciones,
                                a.numero,
                                a.tipo,
                                a._id )}
                            ><i class="far fa-file-pdf"></i>
                            </Button>
                            
            
                          </div>
                        ) : undefined}
                        </td>
                        {/* <td>
                        { a.status == "Abierto" ?(
                          <div>
                                      <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(  
                                        a.fecha,
                                        a.plazo,
                                        a.fecha_compromiso,
                                        // a.fecha_cita,
                                        // a.fecha_cancelacion_pedido,
                                        // a.fecha_creacion_prepedido,
                                        a.idSociedades,
                                        // a.idClientes,
                                        a.total_kilos,
                                        a.total_metros,
                                        a.total_piezas,
                                        a.total_general,
                                        a.observaciones,
                                        a.numero,
                                        a.tipo,
                                        a.empresa,
                                        a._id )}
                                      >
                                      <i class="far fa-edit"></i>
                                      </Button>
                                      <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => EditTelas(a._id, a.numero, a.tipo)}
                                      >
                                      <i class="fas fa-cart-plus"></i>
                                      </Button>
                                      </div>
                              ): (
                                <div>
                                  <Button color="info" id="Editar" size="sm" disabled>
                                    <i class="far fa-edit"></i>
                                  </Button>
                                  <Button
                                      color="info"
                                      id="Editar"
                                      size="sm" disabled>
                                      <i class="fas fa-cart-plus"></i>
                                      </Button>
                                </div>
                              )}
                      </td> */}
                    </tr>
                  );

              })}
            </tbody>
          </Table>
          <div className="col-md-6">
                            <Pagination
                                total={totalItems}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={currentPage}
                                onPageChange={page => setCurrentPage(page)}
                            />
                        </div>
        </div>
      ) : undefined}
      <br />

      {loader}
    </>
  );
}

export default ListadoCompraVenta;
